/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router';
import ContactPage from '../containers/ContactPage';
import ImprintPage from '../containers/ImprintPage';
import { contactPageRoutePrefix } from './router.constants';

class MainRouter extends React.Component {
  render() {
    return (
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route exact path="/imprint" component={ImprintPage} />
          <Route path={contactPageRoutePrefix} component={ContactPage} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default MainRouter;
